var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCopy = function SvgCopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 3h8.25A1.5 1.5 0 0 1 21 4.5v8.25a1.5 1.5 0 0 1-1.5 1.5h-3.75v1.5h3.75a3 3 0 0 0 3-3V4.5a3 3 0 0 0-3-3h-8.25a3 3 0 0 0-3 3v3.75h1.5V4.5a1.5 1.5 0 0 1 1.5-1.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12.75 9.75H4.5a1.5 1.5 0 0 0-1.5 1.5v8.25A1.5 1.5 0 0 0 4.5 21h8.25a1.5 1.5 0 0 0 1.5-1.5v-8.25a1.5 1.5 0 0 0-1.5-1.5M4.5 8.25a3 3 0 0 0-3 3v8.25a3 3 0 0 0 3 3h8.25a3 3 0 0 0 3-3v-8.25a3 3 0 0 0-3-3z",
    clipRule: "evenodd"
  })));
};
export default SvgCopy;